import { baseAPIInstance } from '../instanse';

export const completeMultipartUploadAsync = (data: {
    uploadId: string;
    key: string;
}) => baseAPIInstance.post(`/video/complete-multipart-upload`, data);
